<script setup>

import {computed,defineAsyncComponent} from "vue"
import {useRoute} from "vue-router"
import {useGameFilterProps} from "@shared/composables/useGameFilterProps";

const GameList = defineAsyncComponent(() => import("@shared/components/molecules/GameList.vue"))


defineProps(useGameFilterProps())

const route = useRoute()

const category = computed(() => {
    return route.params.category
})

const categoryName = computed(() => {
    const categories = {
        "live-casino": "Live Casino",
        "table-games": "Table Games",
        "slots": "Slot Games",
        "video-poker": "Video Poker",
        "other-games": "Other Games",
        "live-blackjack": "Live Blackjack",
        "live-dealer": "Live Dealer",
        "live-roulette": "Live Roulette",
        "keno": "Keno Games",
        "baccarat": "Baccarat Games",
        "video-bingo": "Video Bingo",
        "poker": "Poker Games",
        "all-games": "All Games"
    }
    return categories[category.value] || "All Games"
})

</script>

<template>
    <div id="casinogames" class="gamesblock">
        <h1>{{ categoryName }}</h1>
        <GameList
            :filter="filter"
            :product="selectedProvider"
            :sortBy="sortBy"
            group="category"
            :sub-category="category"
            :display-amounts="{xl: 30, md: 20, sm: 12}"
        />
    </div>
</template>
